(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[306],{

/***/ "tkvC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowRight", function() { return ArrowRight; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ArrowRight = function ArrowRight(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M21.4189896,16.4135055 C21.794715,16.0391321 22,15.5400357 22,15.0120627 C22,14.4791745 21.794715,13.9823309 21.4189896,13.6079575 L11.390289,3.58320747 C11.0145637,3.20641739 10.5175788,3 9.98555012,3 C9.4559108,3 8.95653658,3.20641739 8.58320059,3.58320747 C8.20767437,3.95760139 8,4.45440396 8,4.98712835 C8,5.5151014 8.20767437,6.01440252 8.58320059,6.38877596 L17.2097508,15.0120627 L8.58320059,23.632687 C8.20767437,24.0070605 8,24.5063616 8,25.0367922 C8,25.5647653 8.20767437,26.0638616 8.58320059,26.4384398 C9.33226192,27.1871867 10.6390374,27.1871867 11.390289,26.4384398 L21.4189896,16.4135055 Z"
  }));
};

/***/ })

}]);